export type PreparationCheckSummary = {
  latestControlCount: number;
  attentionCount: number;
  readyCount: number;
  exceptionClosedCount: number;
};

export function materialPreparationEmptyState(
  summary: PreparationCheckSummary | null,
) {
  if (!summary)
    return {
      kind: "UNKNOWN" as const,
      title: "Aksiyon gerektiren kontrol gösterilmiyor",
      detail: "Kontrol özetini almak için Yenile ile tekrar deneyin.",
    };
  if (summary.latestControlCount === 0)
    return {
      kind: "NOT_RUN" as const,
      title: "Henüz malzeme kontrolü oluşmadı",
      detail:
        "Planlanan işler üretimden bir gün önceki otomatik kontrol çalıştığında burada değerlendirilir.",
    };
  if (summary.attentionCount > 0)
    return {
      kind: "INCONSISTENT" as const,
      title: "Aksiyon kayıtları gösterilemiyor",
      detail: `${summary.attentionCount} açık kontrol için listeyi yenileyin.`,
    };
  if (summary.exceptionClosedCount > 0)
    return {
      kind: "NO_OPEN_ACTION" as const,
      title: "Açık malzeme aksiyonu yok",
      detail: `Üretime hazır: ${summary.readyCount} · İstisna ile kapatılan: ${summary.exceptionClosedCount}`,
    };
  return {
    kind: "READY" as const,
    title: "Kontrol edilen işler üretime hazır",
    detail: `${summary.readyCount} güncel kontrolde açık malzeme farkı bulunmuyor.`,
  };
}
